import { ProgressAnimationOptions } from 'types';
import { measurementToString } from 'utils/placement';
import { VideoTemplateStateContent } from '../../types';

export function getProgressAnimationOptions(
  state: VideoTemplateStateContent,
): ProgressAnimationOptions {
  const { progress } = state;
  return measurementToString(progress);
}
